var _circle, _circle2, _circle3, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _path4, _path5, _rect6, _rect7, _rect8, _rect9, _rect10, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoiceInFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64.5,
    r: 48,
    fill: "#F7F7F8",
    stroke: "#EEEEF0",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64.5,
    r: 36,
    stroke: "#EEEEF0",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64.5,
    r: 24,
    stroke: "#EEEEF0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 44.5C20 42.2909 21.7909 40.5 24 40.5H104C106.209 40.5 108 42.2909 108 44.5V84.5C108 86.7091 106.209 88.5 104 88.5H24C21.7909 88.5 20 86.7091 20 84.5V44.5Z",
    fill: "#EEEEF0",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7331 88.192C91.2895 91.4587 89.0923 94.5578 85.8256 95.1141L42.4501 102.501C39.1834 103.057 36.0843 100.86 35.528 97.5934L25.0073 35.8162C24.451 32.5495 26.6482 29.4504 29.9148 28.8941L61.4204 23.5287C62.9891 23.2615 64.5997 23.6285 65.8979 24.5488L79.7893 34.3973C81.0874 35.3177 81.9668 36.716 82.2339 38.2847L90.7331 88.192Z",
    fill: "white",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4472 24.2294L80.2397 34.7168C80.8471 35.1475 81.3367 35.7127 81.6756 36.3604C81.9464 36.878 81.5695 37.4548 80.9936 37.5528L66.7429 39.9797C65.896 40.124 65.0925 39.5543 64.9483 38.7074L62.5214 24.4567C62.4233 23.8808 62.8428 23.3343 63.4209 23.4185C64.1443 23.5239 64.8397 23.7988 65.4472 24.2294Z",
    fill: "#EEEEF0",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.0166,
    y: 33.9268,
    width: 7,
    height: 5,
    rx: 2,
    transform: "rotate(-9.66475 48.0166 33.9268)",
    fill: "#EEEEF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.1919,
    y: 40.8271,
    width: 7,
    height: 5,
    rx: 2,
    transform: "rotate(-9.66475 49.1919 40.8271)",
    fill: "#EEEEF0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5874,
    y: 56.1611,
    width: 40,
    height: 4,
    rx: 2,
    transform: "rotate(-9.66475 36.5874 56.1611)",
    fill: "#EEEEF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6016,
    y: 67.9902,
    width: 40,
    height: 4,
    rx: 2,
    transform: "rotate(-9.66475 38.6016 67.9902)",
    fill: "#EEEEF0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.2295,
    y: 36.4443,
    width: 12,
    height: 12,
    rx: 3,
    transform: "rotate(-9.66475 33.2295 36.4443)",
    fill: "#EEEEF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2351 86.2906C93.7013 89.561 90.6174 91.7795 87.3469 91.2457L43.9215 84.1581C40.6511 83.6243 38.4326 80.5404 38.9664 77.27L49.0609 15.4216C49.5946 12.1512 52.6786 9.93271 55.949 10.4665L87.4908 15.6145C89.0613 15.8709 90.4657 16.7406 91.395 18.0324L101.339 31.8555C102.268 33.1473 102.646 34.7553 102.39 36.3258L94.2351 86.2906Z",
    fill: "white",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0723 17.5839L101.661 32.3038C102.096 32.9083 102.376 33.6018 102.486 34.3244C102.574 34.9019 102.031 35.3251 101.454 35.231L87.1872 32.9025C86.3393 32.7641 85.7641 31.9645 85.9025 31.1166L88.2311 16.8495C88.3252 16.273 88.8993 15.8921 89.4188 16.1594C90.0688 16.4938 90.6374 16.9795 91.0723 17.5839Z",
    fill: "#EEEEF0",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 71.4385,
    y: 21.1006,
    width: 7,
    height: 5,
    rx: 2,
    transform: "rotate(9.26971 71.4385 21.1006)",
    fill: "#EEEEF0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70.3105,
    y: 28.0088,
    width: 7,
    height: 5,
    rx: 2,
    transform: "rotate(9.26971 70.3105 28.0088)",
    fill: "#EEEEF0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 53.4126,
    y: 38.4229,
    width: 40,
    height: 4,
    rx: 2,
    transform: "rotate(9.26971 53.4126 38.4229)",
    fill: "#EEEEF0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 51.4795,
    y: 50.2666,
    width: 40,
    height: 4,
    rx: 2,
    transform: "rotate(9.26971 51.4795 50.2666)",
    fill: "#EEEEF0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 56.6343,
    y: 18.6846,
    width: 12,
    height: 12,
    rx: 3,
    transform: "rotate(9.26971 56.6343 18.6846)",
    fill: "#EEEEF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6863 48.5H20.5311C18.1251 48.5 16.2636 50.6087 16.562 52.9961L23.124 105.492C23.6245 109.496 27.0277 112.5 31.0623 112.5H97.1468C101.091 112.5 104.447 109.625 105.052 105.728L111.283 65.614C111.66 63.1892 109.785 61 107.331 61H65.4706C62.288 61 59.2357 59.7357 56.9853 57.4853L50.3431 50.8431C48.8429 49.3429 46.808 48.5 44.6863 48.5Z",
    fill: "#F7F7F8",
    stroke: "#B9BAC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96 106.5H32",
    stroke: "#D9D9DE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceInFolder);
export default __webpack_public_path__ + "static/media/invoice-in-folder.e0a2ed99efd4a8aa06d549cb793d864f.svg";
export { ForwardRef as ReactComponent };